import type {
  MobileUnitAssignmentValidated,
  MobileUnitWarnings,
} from '@models';

export const getAssignmentsForMobileUnit = (
  assignments: MobileUnitAssignmentValidated[] | undefined,
  mobileUnitId: string
) => {
  return (assignments ?? [])
    .filter((assignment) => assignment.mobileUnit.id === mobileUnitId)
    .sort(
      (first, second) =>
        new Date(first.validFrom).getTime() -
        new Date(second.validFrom).getTime()
    );
};

export const getAssignmentWarnings = (
  technicianWarnings: Record<string, MobileUnitWarnings[]> | undefined,
  assignmentId: string
) => {
  if (!technicianWarnings || !(assignmentId in technicianWarnings)) {
    return [];
  }

  return technicianWarnings[assignmentId] ?? [];
};
